module.exports = __webpack_public_path__ + "media/goforajourney/img/madrid-tour-4063c35143d27aad333c8951b87127dd.jpg";